import React from 'react';
import "tabler-react/dist/Tabler.css";
import { Button, Page } from "tabler-react";
import { Component } from 'react';

class LogIn extends Component {

	loginComponente = () => {
		window.location.href = "/login";
	}

	render() {
		return (
			<>
			<Page.Content className="page-login">
				<div className="login-container">
					<div className="form-side">
						<div className="login-logo">
							<img src="/media/IEU.png" alt="Logotipo de IEU" />
						</div>
						<div className="form">
							<h1>Dashboard de Docentes</h1>
							<p>Bienvenido a tu Dashboard de docentes</p>
							<Button color="primary" className="ml-auto btn-ieu-login" value="OneloLogin" onClick={this.loginComponente}>
								Ingresar
							</Button>
						</div>
					</div>
					<div className="heroe"></div>
				</div>
			</Page.Content>
			</>
		);
	}
}

export default LogIn;